import useSWR from 'swr';
import { get, post } from './api';

type Session = { email: string; canChangePlacedOrders?: boolean };

export function useSession() {
  const { data, error, isLoading, mutate } = useSWR<Session>(
    '/api/auth/me',
    (url: string) => get<Session>(url),
    { shouldRetryOnError: false, revalidateOnFocus: false }
  );
  return {
    user: data,
    isAuthenticated: !!data && !error,
    isLoading,
    refresh: mutate,
  };
}

export async function logout() {
  await post('/api/auth/logout', {});
  window.location.href = '/login';
}
